export * from './decoration-settings.component';
